import Button from '../../../components/base/Button';

export default function ProgramsSection() {
  const programs = [
    {
      title: "HVAC Technician",
      subtitle: "Figure out why heating and cooling systems break down",
      description: "Our HVAC training program equips you with the skills and knowledge needed to excel in the heating, ventilation, and air conditioning industry. Dive into an online learning experience with real-world applications.",
      link: "/hvac-training",
      image: "https://public.readdy.ai/ai/img_res/72ac1d9121253daba4d8f3fab7eff112.jpg"
    },
    {
      title: "Appliance Repair Technician",
      subtitle: "Solve issues that cause appliances to stop working",
      description: "Explore the world of appliance repair through our comprehensive online courses. From basic principles to advanced techniques, our program covers everything you need to kickstart a successful career in repairing major appliances.",
      link: "/appliance-repair",
      image: "https://readdy.ai/api/search-image?query=thirty%20five%20year%20old%20african%20american%20male%20professional%20appliance%20repair%20technician%20wearing%20work%20uniform%20using%20multimeter%20and%20diagnostic%20tools%20to%20troubleshoot%20refrigerator%20compressor%20and%20cooling%20system%20examining%20electrical%20connections%20with%20focused%20concentration%20in%20modern%20kitchen%20setting%20bright%20clean%20lighting%20realistic%20detailed%20photography&width=400&height=250&seq=appliance-african-american-fridge-repair-002&orientation=landscape"
    },
    {
      title: "Electrician",
      subtitle: "Acquire essential training for electrical wiring and equipment",
      description: "Join our journeyman electrician program to gain practical skills and theoretical knowledge essential for a successful career in the electrical industry. Learn from industry experts through our online platform.",
      link: "/electrical-work",
      image: "https://readdy.ai/api/search-image?query=twenty%20year%20old%20dark%20skinned%20mexican%20male%20professional%20electrician%20working%20on%20complex%20electrical%20panel%20and%20industrial%20wiring%20systems%20in%20factory%20manufacturing%20setting%20wearing%20safety%20helmet%20and%20work%20uniform%20using%20electrical%20testing%20equipment%20and%20tools%20focused%20on%20troubleshooting%20power%20distribution%20systems%20bright%20industrial%20lighting%20realistic%20detailed%20photography&width=400&height=250&seq=mexican-electrician-industrial-repair-003&orientation=landscape"
    }
  ];

  const handleLearnMore = (link: string) => {
    window.REACT_APP_NAVIGATE(link);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <section id="programs" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4 uppercase">
            Enhance Your<br />
            Career Options
          </h2>
          <p className="text-xl text-gray-700 font-semibold">
            Earn industry certifications that position you to land a job in these high demand fields
          </p>
        </div>

        {/* Programs Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {programs.map((program, index) => (
            <div key={index} className="bg-gray-50 border-4 border-blue-500 text-gray-900 p-6 rounded-lg hover:shadow-lg transition-shadow flex flex-col h-full">
              <h3 className="text-2xl font-bold mb-3 text-center">{program.title}</h3>
              
              {/* Program Image */}
              <div className="w-full h-40 mb-3 rounded-md overflow-hidden">
                <img 
                  src={program.image} 
                  alt={`${program.title} professional at work`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              
              <p className="text-base mb-3 text-gray-600 font-bold">{program.subtitle}</p>
              <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-grow">
                {program.description}
              </p>
              <Button 
                onClick={() => handleLearnMore(program.link)}
                variant="outline"
                className="border-yellow-400 text-black bg-yellow-400 hover:bg-yellow-500 whitespace-nowrap w-full"
              >
                Learn More
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
